import React from "react";
import ImageListItem from "@mui/material/ImageListItem";
import ImageList from "@mui/material/ImageList";
import {isMobile} from 'react-device-detect';

/**
 *
 * @param sectionHeadingTitle
 * @param sectionHeadingMessage
 * @param extraBlockInfo usually html containing an image
 * @returns {Element}
 * @constructor
 */
export default function SectionHeading({sectionHeadingTitle, sectionHeadingMessage, images}) {

    function srcset(image, size, rows = 1, cols = 1) {
        return {
            src: `${image}?w=${size * cols}&h=${size * rows}&fit=crop&auto=format`,
            srcSet: `${image}?w=${size * cols}&h=${
                size * rows
            }&fit=crop&auto=format&dpr=2 2x`,
        };
    }

    return (

        <div className="row">
            <div className="col-lg-7">
                <h2 className="section-heading"><strong>{sectionHeadingTitle}</strong></h2>
                {sectionHeadingMessage && <p className="mb-5">{sectionHeadingMessage}</p>}
            </div>
            <div className="col-lg-5">
                {images &&
                    <ImageList
                        variant="quilted"
                        cols={4}
                        rowHeight={isMobile ? 120 : 200}
                    >
                        {images.map((item) => (
                            <ImageListItem key={item.img} cols={item.cols || 1} rows={item.rows || 1}>
                                <img
                                    {...srcset(item.img, 121, item.rows, item.cols)}
                                    alt={item.title}
                                    loading="lazy"
                                />
                            </ImageListItem>
                        ))}
                    </ImageList>
                }
            </div>
        </div>
    );
}